import {
  defaultBorders,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  GSEmptyList,
  GSItemList,
} from "golfstatus_react_components";
import React, { useEffect, useRef } from "react";
import TournamentLeaderboardResultLineItem from "./tournament-leaderboard-result-line-item";
import { useTheme } from "../../../../hooks/themeHooks";
import { useDispatch, useSelector } from "react-redux";
import {
  getLeaderboard,
  selectLoading,
} from "../../../../reducers/leaderboardSlice";
import { useTournament } from "../../../../hooks/tournamentHooks";

const LeaderboardResultList = (props) => {
  const {
    leaderboard,
    flights,
    readOnly,
    emptyMessage,
    itemSelected,
    style,
    delay,
  } = props;

  const search = props?.search ?? "";

  const tournament = useTournament();
  const tournamentID = tournament?.id ?? "";
  const leaderboardID = leaderboard?.id ?? "";

  const loading = useSelector(selectLoading);

  const dispatch = useDispatch();

  const interval = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      interval.current = setInterval(() => {
        if (tournamentID !== "" && leaderboardID !== "") {
          dispatch(getLeaderboard(leaderboardID));
        }
      }, 60000);
    }, delay ?? 10000);
    return () => {
      clearInterval(interval.current);
    };
  }, [dispatch, tournamentID, leaderboardID, delay]);

  const currentFlights = flights?.filter?.(
    (f) =>
      f.leaderboardTypeSetting?.id === leaderboard?.leaderboardTypeSetting?.id
  );

  const [, theme, getStyle] = useTheme();

  const getName = (score) => {
    return score?.name?.toLowerCase?.();
  };

  const getSkinName = (score) => {
    return score?.winner?.toLowerCase?.();
  };

  const getMatchName = (score) => {
    const teams = score?.matchScores?.flatMap?.((ms) => ms?.playerHash);
    const teamNames = teams?.map((t) => t.name?.toLowerCase?.());
    return teamNames?.join?.(" ");
  };

  const getScores = () => {
    const skins = leaderboard?.scoresAbbrev?.filter?.((s) =>
      getSkinName(s)?.includes?.(search?.toLowerCase?.())
    );
    const results =
      leaderboard?.scoringSystem === "match_play" &&
      leaderboard?.type === "round_match"
        ? leaderboard.scores?.filter?.((s) =>
            getMatchName(s)?.includes?.(search?.toLowerCase?.())
          )
        : leaderboard?.scores?.filter?.((s) =>
            getName(s)?.includes?.(search?.toLowerCase?.())
          );
    return skins?.length > 0
      ? skins
          ?.filter?.((s) => s.winner !== "-")
          .map?.((s) => {
            return { ...s, skin: true };
          })
      : results;
  };

  const getTeamIndex = (flight) => {
    const index = getScores()?.findIndex?.(
      (s) => s.teamKey === flight?.teamFlights?.[0]?.teamScores?.teamKey
    );
    return index;
  };

  let leaderboardFlights = [];

  if (currentFlights?.length > 0 && leaderboard?.type !== "skins") {
    leaderboardFlights = currentFlights?.map?.((f, index) => ({
      index: getTeamIndex(f),
      view: (
        <div
          style={{
            ...defaultTypography.headline3,
            ...defaultPadding.xLargePad.apply("vertical"),

            ...defaultLayouts.fullWidth,
            ...defaultLayouts.hStack.align("flex-start", "center"),
          }}
        >
          <div
            style={{ height: "100%", ...getStyle(theme.surface) }}
          >{`${f.name} Flight`}</div>
        </div>
      ),
    }));
  }

  const getEmptyList = () => {
    return (
      <GSEmptyList
        style={{ ...defaultPadding.emptyListPad, ...defaultLayouts.fill }}
        title={leaderboard.name}
        detail={<center>{`This leaderboard does not yet have results to show.`}</center>}
      />
    );
  };
  return (
    <leaderboard-result-list
      style={{
        ...defaultLayouts.vStack,
        ...defaultLayouts.fullWidth,
        ...style,
      }}
    >
      <GSItemList
        style={{ ...defaultLayouts.fullWidth }}
        type="vertical selectable small-gap alternate"
        items={getScores(leaderboard)}
        indexItems={leaderboardFlights}
        listItem={(item) => (
          <TournamentLeaderboardResultLineItem
            className={item?.skin || readOnly ? "" : "hover-color-shift"}
            style={{
              ...getStyle(theme.surfaceVariant),
              ...defaultBorders.mediumLargeBorderRadius,
              ...defaultLayouts.fullWidth,
            }}
            leaderboard={leaderboard}
            {...item}
            hideFavorite={readOnly}
          />
        )}
        itemSelected={(team) => {
          itemSelected?.(team);
        }}
        emptyMessage={emptyMessage ?? getEmptyList()}
        loading={loading?.includes?.("getPublicLeaderboards")}
        loadingMainText="Loading Leaderboards"
      ></GSItemList>
    </leaderboard-result-list>
  );
};

export default LeaderboardResultList;
